/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "slick", "args" : "none" }]*/
import $ from 'jquery';
import {slick} from 'slick-carousel';


///////////////////////////////////
// Slider
// ---
class Slider {
  constructor(component) {
    this.$component = $(component);
    this.$items = this.$component.find('.js-slider__items');
    this.config = {
      speed: window.app.env.speed.normal,
    }
  }

  init() {
    this.$items.slick(this.config);
    return this;
  }
}

///////////////////////////////////
// ContentSlider
// ---
class ContentSlider extends Slider {
  constructor(component) {
    super(component);
    this.config = {
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: this.$component.find('.js-slider__nav-button--prev'),
      nextArrow: this.$component.find('.js-slider__nav-button--next'),
      responsive: [
      {
        breakpoint: window.app.env.breakpoints.l, // < 780
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: window.app.env.breakpoints.m, // < 460
        settings: 'unslick'
      }
      ]
    }
  }
}

///////////////////////////////////
// StageSlider
// ---
class StageSlider extends Slider {
  constructor(component) {
    super(component);
    this.$buttons = this.$component.find('.js-slider__button');
    this.config = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      pauseOnFocus: true,
      waitForAnimate: false
    }
  }

  setButtonState(e, slick, currentSlide = 0, nextSlide = 0) {
    let $button = this.$buttons.eq(nextSlide);
    this.$buttons.removeClass('active');
    $button.addClass('active');
  }

  slideTo(e) {
    let i = $(e.currentTarget).index();
    this.$items.slick('slickGoTo',i);
  }

  init() {
    let _this = this;
    this.$items.on('beforeChange init',_this.setButtonState.bind(_this));
    this.$items.slick(this.config);
    this.$buttons.on('mouseenter.slide',_this.slideTo.bind(_this));
    this.$component.on('mouseenter.slide', function(){
      _this.$items.slick('slickPause');
    }).on('mouseleave.slide', function(){
      _this.$items.slick('slickPlay');
    });
    return this;
  }
}

module.exports = {
  ContentSlider: ContentSlider,
  StageSlider: StageSlider
};



// WEBPACK FOOTER //
// ./components/slider.js